import datetimeProvider from "../../../../../providers/datetime.provider";
import { packages } from "../../../../constant/marketing/product.constant";

const VALIDITY_NOTE = (
    <span>
        Preço promocional até <s style={{ opacity: 0.6 }}>18/07</s>{" "}
        <strong style={{ background: "#6366F1", color: "#fff", fontWeight: 800, borderRadius: 5, padding: "1px 9px", whiteSpace: "nowrap" }}>31/07</strong>
    </span>
);

const eventSmart2026Config = {
    key: "smart2026",
    label: "Promoção Smart",
    initialDate: "2026-07-13",
    finalDate: "2026-07-31",
    validator: function () {
        return datetimeProvider.getDate().isBetween(this.initialDate, this.finalDate, "day", "[]");
    },
    priceTableNote: "Cálculo Complexo com preço promocional até 31/07.",
    additionalMessage: () => (
        <div className="text-center mt-10">
            <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 max-w-2xl mx-auto">
                <p className="text-sm font-medium text-indigo-700">
                    ✨ Promoção Smart: Cálculo Complexo com preço promocional até <s className="opacity-60">18/07</s> <strong className="bg-indigo-500 text-white font-extrabold rounded px-2.5 py-0.5 whitespace-nowrap">31/07</strong>.
                </p>
            </div>
        </div>
    ),
    packages: {
        [packages.start.id]: {
            name: "Start Smart",
            note: VALIDITY_NOTE,
            couponChip: {
                border: "#6366F1",
                color: "#4F46E5",
                text: "✨ Smart · Cálculo Complexo R$ 260",
            },
        },
        [packages.premium.id]: {
            name: "Premium Smart",
            note: VALIDITY_NOTE,
            couponChip: {
                border: "#A5B4FC",
                color: "#C7D2FE",
                text: "✨ Smart · Cálculo Complexo R$ 240",
            },
        },
        [packages.infinity.id]: {
            name: "Infinity Smart",
            note: VALIDITY_NOTE,
            couponChip: {
                border: "#6366F1",
                color: "#4F46E5",
                text: "✨ Smart · Cálculo Complexo R$ 200",
            },
        },
    },
};

export default eventSmart2026Config;
